// Formerly an inline <script> in public/index.html. Moved into the bundle so the
// CSP can drop 'unsafe-inline' from scripts. Sets the title/favicon for the JKC
// (jkyms.com) white-label build; no-op for the default Dice build.
(function applyBranding() {
	if (typeof window === 'undefined') return;
	var isJkc = window.location.href.indexOf('jkyms.com') !== -1;
	if (!isJkc) return;
	document.title = 'JKC Vendor Portal';
	var favicon = document.getElementById('favicon');
	if (favicon) {
		favicon.href = '/jkclogo.png';
	}
})();
